'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ToggleChoice = _react2['default'].createClass({
    displayName: 'ToggleChoice',

    handleClick: function handleClick() {
        this.props.handleSelection(this.props.value);
    },
    render: function render() {

        var classes = (0, _classnames2['default'])({
            'small-6': true,
            'columns': true,
            'm-toggle--choice': true,
            'is-active': this.props.isActive,
            'is-inactive': !this.props.isActive
        });
        return _jsx('div', {
            className: classes,
            onClick: this.handleClick
        }, void 0, this.props.name);
    }
});

var Toggle = _react2['default'].createClass({
    displayName: 'Toggle',

    propTypes: {
        initialSelection: _react2['default'].PropTypes.string
    },
    getInitialState: function getInitialState() {
        var selected = this.props.choices[0].value;
        if (this.props.initialSelection) {
            for (var i = 0; i < this.props.choices.length; i++) {
                if (this.props.initialSelection == this.props.choices[i].value) {
                    selected = this.props.choices[i].value;
                    break;
                }
            }
        }
        return { selected: selected };
    },
    handleSelection: function handleSelection(selected) {
        this.setState({ 'selected': selected });
        this.props.onSelection(selected);
    },
    render: function render() {
        var choices = this.props.choices.map(function (choice, i) {
            return _jsx(ToggleChoice, {
                name: choice.name,
                value: choice.value,
                handleSelection: this.handleSelection,
                isActive: this.state.selected == choice.value
            }, 'choice' + i, choice.name);
        }.bind(this));
        return _jsx('div', {
            className: 'small-6 small-centered large-3 large-centered columns m-toggle'
        }, void 0, choices);
    }
});
exports.Toggle = Toggle;
exports.ToggleChoice = ToggleChoice;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/toggle.jsx
 ** module id = 795
 ** module chunks = 0
 **/